module.exports = __webpack_public_path__ + "media/images/countryrect/vi-50e1356f27b6d363e1e0fccdf2796ed7.svg";